/**
 * AvatarImage
 */
import React from 'react';
import { Icon } from '..';
/** Main description for this component. */
var AvatarImage = function (_a) {
    var image = _a.image, _b = _a.alt, alt = _b === void 0 ? '' : _b, uhmIcon = _a.uhmIcon;
    return (React.createElement("div", { className: "relative w-16 h-16" },
        React.createElement("div", { className: "image__object-fit w-full h-full border border-greySemiLight rounded-full mr-3" },
            React.createElement("img", { height: "64", width: "64", src: image + '?width=64', alt: alt || '', className: "mb-0" })),
        uhmIcon && (React.createElement(Icon, { icon: "uhmBadge", size: 2, className: "absolute top-0 right-0", "aria-hidden": true }))));
};
export default AvatarImage;
